<template>
  <div class="c-base-input-quotas">
    <p class="label">
      {{ label }}
    </p>

    <div class="quotas-wrap">
      <div class="quotas">
        <span>Cotas:</span>
        <button @click="subtractQuota" type="button" class="action-button">
          <base-icon
            width="22"
            height="22"
            class="icon"
            name="painel/sub-circle"
          />
        </button>
        {{ quotas }}
        <button @click="plusQuota" type="button" class="action-button">
          <base-icon class="icon" name="painel/plus-circle" />
        </button>
      </div>
      <div v-if="quotas > 0" class="accounting">
        {{ quotas }} de R$ {{ quotaPriceFormatted }}
      </div>
    </div>
  </div>
</template>

<script>
import currency from 'currency.js'

export default {
  props: {
    label: {
      type: String,
      default: 'Em quantas cotas você quer dividir este presente?',
    },
    quotas: {
      type: Number,
      default: 0,
    },
    price: {
      type: Number,
      default: 0,
    },
    minQuotaPrice: {
      type: Number,
      default: 1,
    },
  },

  computed: {
    quotaPrice() {
      return this.price / this.quotas
    },

    quotaPriceFormatted() {
      return currency(this.quotaPrice, {
        separator: '.',
        decimal: ',',
      }).format()
    },
  },

  data() {
    return {}
  },

  methods: {
    plusQuota() {
      const quotas = this.quotas + 1
      const newQuotaPrice = this.price / quotas
      if (newQuotaPrice >= this.minQuotaPrice) {
        this.$emit('change', quotas)
      }
    },

    subtractQuota() {
      if (this.quotas > 0) {
        this.$emit('change', this.quotas - 1)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.c-base-input-quotas {
  display: flex;
  flex-direction: column;

  .label {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: $neutral;
    margin-bottom: 8px;

    > .icon {
      margin-left: 8px;
    }
  }

  .quotas-wrap {
    display: flex;
    align-items: center;
    height: 48px;
    padding: 0 12px;
    border-radius: 8px;
    border: 1px solid $neutrallight;
  }

  .quotas {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;

    > .action-button {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      padding: 0;
      margin: 0 8px;
      cursor: pointer;
      border: 0;
      line-height: 1;
      background-color: transparent;
      > .icon {
        color: $primary;
      }
    }
  }

  .accounting {
    position: relative;
    padding-left: 16px;

    &:before {
      content: '|';
      position: absolute;
      left: 0;
    }
  }
}
</style>
